
export interface ModelStatus {
  /** 모델 사용 가능 여부 */
  available?: boolean;
  /** 오류 메시지 (있는 경우) */
  error?: string;
  /** 마지막 상태 확인 시간 */
  last_check?: string;
  /** 제공자 */
  provider?: string;
}
